import { InteractionType, useKEAGraphContext } from "context/KEAGraphContext";
import { useNameModelModalContext } from "context/NameModelModalContext";
import { useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { CustomModalCard } from "../../modals/CustomModalCard";

type Props = {};

export const ModelExportButton = (_props: Props) => {
  const keaGraphContext = useKEAGraphContext();
  const nameModelModalContext = useNameModelModalContext();
  const { t } = useTranslation();
  const [isNaming, setIsNaming] = useState(false);
  const [name, setName] = useState("");

  const openDialog = () => {
    setName((nameModelModalContext.name || "").trim());
    setIsNaming(true);
  };

  const exportModel = () => {
    // An allow list would drop umlauts, and German model names almost always contain them.
    const trimmed = name.trim();
    const fileName = trimmed ? trimmed.replace(/[/\\:*?"<>|]/g, "_") + ".kea" : "model.kea";
    keaGraphContext.modelingGraph.download(fileName);
    keaGraphContext.addUserInteraction(InteractionType.GRAPH_DOWNLOAD, Date.now());
    setIsNaming(false);
  };

  return (
    <>
      <button className="button is-primary is-rounded" onClick={openDialog}>
        {t("export")}
      </button>

      {/* The button group renders its children inside a <p>, which must not contain a dialog. */}
      {createPortal(
        <CustomModalCard
          isActive={isNaming}
          setisActive={() => setIsNaming(false)}
          header={t("ExportModelModalHeader") as string}
          body={
            <div className="field">
              <label className="label">{t("NameModelModalInputFieldLabel")}</label>
              <div className="control">
                <input
                  className="input"
                  type="text"
                  autoFocus
                  placeholder={t("NameModelModalInputFieldPlaceholder") as string}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      exportModel();
                    }
                  }}
                />
              </div>
              <p className="help">{t("ExportModelModalInputFieldHelper")}</p>
            </div>
          }
          footer={
            <>
              <button
                type="button"
                className="button is-warning"
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  setIsNaming(false);
                }}
              >
                {t("cancel")}
              </button>
              <button
                type="button"
                className="button is-primary"
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  exportModel();
                }}
              >
                {t("export")}
              </button>
            </>
          }
        />,
        document.body,
      )}
    </>
  );
};
